'use client'

import axios from 'axios'
import type { Dispatch, SetStateAction } from 'react'
import { useToast } from '@/app/context/toast-provider'
import { ERROR_MESSAGES } from '@/app/utils/errorMessage'

export type UseSaveInterviewOptions = {
    interview: any
    setInterview: Dispatch<SetStateAction<any>>
    refreshJobApplicationList?: () => void
    setRequestLoading?: (loading: boolean) => void
}

/**
 * Saves the interview's own fields — the final result (`finalComments`, `finalStatus`) and its rounds — with
 * `PUT /api/interviews/{id}/`, then replaces the interview with the response (keeping the candidate email, which the
 * response drops).
 */
export function useSaveInterview({ interview, setInterview, refreshJobApplicationList, setRequestLoading }: UseSaveInterviewOptions) {
    const { showErrorToast, showSuccessToast } = useToast()

    return async (updatedInterview: any) => {
        try {
            setRequestLoading?.(true)
            const res = await axios.put(`/api/interviews/${interview.id}/`, {
                finalComments: updatedInterview.finalComments,
                finalStatus: updatedInterview.finalStatus,
                interviewRounds: updatedInterview.InterviewRounds,
            })

            if (res.status === 200) {
                setInterview({ ...res.data.data, email: interview?.email })
                showSuccessToast(res.data.message)
                refreshJobApplicationList?.()
                setRequestLoading?.(false)
            }
        } catch {
            showErrorToast(ERROR_MESSAGES.SAVE_INTERVIEW_FAIL)
            setRequestLoading?.(false)
        }
    }
}
